var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00347 13.1582L9 13.6306C9.00347 15.909 10.5977 17.8193 12.7546 18.3611C12.7997 18.3646 12.8449 18.3785 12.8866 18.3924C13.0915 18.4619 13.2374 18.6321 13.3068 18.837V20.8758C13.3068 21.2544 13.616 21.56 14.0015 21.56H14.005C14.3905 21.56 14.6961 21.2544 14.6961 20.8758V18.8335C14.7656 18.6286 14.908 18.4619 15.1129 18.3924C15.1546 18.3785 15.1998 18.3646 15.2484 18.3611C17.4053 17.8193 19.003 15.909 19.003 13.6306V13.1582C19.003 12.797 18.6938 12.5018 18.3257 12.5018C17.9575 12.5018 17.6484 12.7935 17.6484 13.1582V13.6306C17.6484 14.6205 17.249 15.5096 16.5856 16.1591C15.9187 16.8051 15.0122 17.208 13.998 17.208C12.9838 17.208 12.0842 16.8086 11.4209 16.1591C10.7575 15.5096 10.3546 14.617 10.3546 13.6306V13.1582C10.3546 12.797 10.0489 12.5018 9.67728 12.5018C9.30912 12.5018 9.00347 12.797 9.00347 13.1582Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3271 8.62925V13.6238C11.3271 15.0756 12.5324 16.253 14.0189 16.253C15.5055 16.253 16.7107 15.0756 16.7107 13.6238V8.62925C16.7107 7.17743 15.5055 6 14.0189 6C12.5324 6 11.3271 7.17743 11.3271 8.62925Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.cc4ca038975f7c69c9cb3bd93fdc7836.svg";
export { ForwardRef as ReactComponent };